import type { CSSProperties, ReactNode } from 'react';

/**
 * StatusPill
 * --------------------------------
 * 全局状态徽章 (Pill)。覆盖卡片生命周期、订单状态、清算状态。
 * 颜色语义遵循设计规范：
 *   - processing  品牌蓝（处理中）
 *   - success     成功绿（终态成功）
 *   - warning     警示橙（异常但可恢复）
 *   - danger      危险红（终态失败 / 拒绝 / 销户）
 *   - default     灰色（未知 / 关闭）
 */
export type StatusTone = 'processing' | 'success' | 'warning' | 'danger' | 'default';

const toneStyle: Record<StatusTone, CSSProperties> = {
  processing: {
    color: '#165DFF',
    background: '#E8F3FF',
    borderColor: '#BEDAFF',
  },
  success: {
    color: '#00B42A',
    background: '#E8FFEA',
    borderColor: '#AFF0B5',
  },
  warning: {
    color: '#FF7D00',
    background: '#FFF7E8',
    borderColor: '#FFCF8B',
  },
  danger: {
    color: '#F53F3F',
    background: '#FFECE8',
    borderColor: '#FBACA3',
  },
  default: {
    color: '#4E5969',
    background: '#F2F3F5',
    borderColor: '#E5E6EB',
  },
};

export interface StatusPillProps {
  tone?: StatusTone;
  children: ReactNode;
}

export function StatusPill({ tone = 'default', children }: StatusPillProps) {
  return (
    <span className="up-status-pill" style={toneStyle[tone]}>
      {children}
    </span>
  );
}
